import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppForumTopicsPage } from './app-forum-topics';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppForumTopicsPage,
  ],
  imports: [
    IonicPageModule.forChild(AppForumTopicsPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppForumTopicsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-forum-topics/app-forum-topics.module.ts